import { gridSizeMdLg12, ROUTER_PATHS } from "@/shared";
import { useFetchPostProductoServicio, useFetchPutProductoServicio } from "@/shared/actions/erp/producto_servicio.action";
import { CustomTextField, SingleFormBoxScene } from "@/shared/components/ui";
import { IProductoServicio, IProductoServicioForm } from "@/shared/interfaces/erp/administration/producto_servicio.interface";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

interface SaveProductoServicioProps {
  title: string
  productoServicio?: IProductoServicio
}

export default function SaveProductoServicio({
  title,
  productoServicio
}: SaveProductoServicioProps) {

  const navigate = useNavigate();

  const form = useForm<IProductoServicioForm>({

  });

  const {
    handleSubmit,
    control,
    formState: { errors, isValid }
  } = form


  ///* fetch

  const fetchUpdate = useFetchPutProductoServicio({
    navigate,
    returnUrl: ROUTER_PATHS.inventario.servicio
  });

  const fetchCreate = useFetchPostProductoServicio({
    navigate,
    returnUrl: ROUTER_PATHS.inventario.servicio
  })

  ///* handlers
  const onSave = (form: IProductoServicioForm) => {
    if (!isValid) return;

    if (productoServicio) {
      fetchUpdate.mutateAsync({
        id: productoServicio.id_servicio,
        data: form
      })

      return;
    }

    fetchCreate.mutateAsync(form);
  };

  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => {
        navigate(ROUTER_PATHS.inventario.servicio);
      }}
      onSave={handleSubmit(onSave, () => {

      })}

    >

      <CustomTextField
        control={control}
        name="codigo"
        defaultValue={form.getValues().codigo}
        size={gridSizeMdLg12}
        label={'Codigo'}
        error={errors.codigo}
        helperText={errors.codigo?.message}
      />

      <CustomTextField
        control={control}
        name="codigo"
        defaultValue={form.getValues().codigo}
        size={gridSizeMdLg12}
        label={'Nombre'}
        error={errors.codigo}
        helperText={errors.codigo?.message}
      />

      <CustomTextField
        control={control}
        name="codigo"
        defaultValue={form.getValues().codigo}
        size={gridSizeMdLg12}
        label={'Precio'}
        error={errors.codigo}
        helperText={errors.codigo?.message}
      />

    </SingleFormBoxScene>
  )

}